import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { INPUT_TITLE_MAP } from '../inputs'

const propTypes = {
  /**
   * Input name
   */
  input: PropTypes.string.isRequired,
  /**
   * callback to decide if input should be displayed or not
   * If return true, input is displayed
   */
  displayInput: PropTypes.func,
  /**
   * Function to render input. Should return a react node. Params: input
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * If true, make the label (title) of item bold
   */
  labelBold: PropTypes.bool,
}

const defaultProps = {
  displayInput: () => true,
  labelBold: false,
}

function InputRow(props) {
  const { input, displayInput, renderInput, labelBold } = props

  if (!displayInput(input)) {
    return null
  }

  const messageId = INPUT_TITLE_MAP[input]

  return (
    <Row className="mb-3">
      <Col md="5" className={clsx(labelBold && 'text-bold')}>
        {messageId && <FormattedMessage id={messageId} />}
      </Col>
      <Col md="7">{renderInput(input)}</Col>
    </Row>
  )
}

InputRow.propTypes = propTypes
InputRow.defaultProps = defaultProps

export default InputRow
